module.exports = __webpack_public_path__ + "img/loading.7f0d7ae2.gif";